import type {components} from '@/types/hydras.d'

export enum HydraulicSelectorState {
  startpage = 'startpage',
  newconstruction = 'newconstruction',
  replacement = 'replacement',
}
export type Checkboxes = {
  [key: string]: boolean;
};
export interface inputs {
  BasicInputs: {
    rodDiameter?: number | null;
    outerDiameter?: number | null;
    applicationArea?: string | null;
    applicationAreaUnknown?: boolean | null;
    sealsNeeds?: string | null;
  };
}
type RequestBody = components['schemas']['ApiPostProductRequest'];

export interface HydraulicSelectorModule {
  selectorState: Ref<HydraulicSelectorState>;
  currentData: Ref<RequestBody>;
  presets: Ref<components['schemas']['ApiApplicationPreset'][]>;
  presetsImperial: Ref<components['schemas']['ApiApplicationPreset'][]>;
  metadata: Ref<components['schemas']['ApiHydraulicMetaData']>;
  metadataImperial: Ref<components['schemas']['ApiHydraulicMetaData']>;
  presetsAndMetadataInitialized: ComputedRef<boolean>;
  dataIncompleteForStepTwo: ComputedRef<boolean>
  replacementStep: Ref<number>
  wiperProfile: Ref<string>
  rodSealProfile: Ref<string>
  rodGuideProfile: Ref<string>
  bufferSealProfile: Ref<string>
  pistonSealProfile: Ref<string>
  pistonGuideProfile: Ref<string>
  wiperDefault: Ref<string>
  pistonSealDefaultB: Ref<boolean>
  isErrorResponse: Ref<boolean>
  isInch: ComputedRef<boolean>
  unitLength: Ref<string>
  unitTemperature: Ref<string>
  unitPressure: Ref<string>
  unitSpeed: Ref<string>
  usStandardSizes: Ref<boolean>
  unitSwitchingEnabled: ComputedRef<boolean>
  // eslint-disable-next-line no-undef
  getPostRequestObject: ComputedRef<ApiPostProductRequest>
  setSelectorState: (state: HydraulicSelectorState) => void;
  setCurrentData: (data: RequestBody) => void;
  setCurrentDataMultiple: (
    properties: { key: keyof RequestBody; value: any }[]
  ) => void;
  setPresets: (data: components['schemas']['ApiApplicationPreset'][]) => void;
  setMetadata: (data: components['schemas']['ApiHydraulicMetaData']) => void;
  setUnitLength: (value: string) => void;
  setUnitPressure: (value: string) => void;
  setUnitSpeed: (value: string) => void;
  setUnitTemperature: (value: string) => void;
  setUsStandardSizes: (value: boolean) => void;
  loadDefaultData: (forceUpdate: boolean) => void;
  basicInput: Ref<inputs['BasicInputs']>;
  checkboxes: Ref<Checkboxes>;
  resetState: () => void;
  initializeUnits: () => void;
}
